<template>
    <nav aria-label="Page navigation example">
        <ul class="pagination">
            <li
                v-for="key in pageCount"
                :key="key"
                class="page-item"
                :class="[ pageNumber === key - 1 ? 'active' : '']"
                @click="goToPage(key)"
            >
                <span class="page-link" >{{key}}</span>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        pageCount: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            pageNumber: 0,
        }
    },
    watch: {
        pageNumber: {
            handler(toPage, fromPage) {
                this.$emit('pageChange', fromPage, toPage)
            },
            immediate: true
        },
    },
    methods: {
        nextPage() {
            this.pageNumber++;
        },
        prevPage() {
            this.pageNumber--;
        },
        goToPage(page) {
            this.pageNumber = page - 1;
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/common/Pagination.vue